export interface PlanType {
  key: string;
  name: string;
  description: string;
  cost: number;
  selectable?: boolean;
  upgradeMethod: 'none' | 'user' | 'sales';
  features: Array<string>;
  weight: number;
}

const Plans: { plans: { TYPES: PlanType[] } } = {
  plans:  {
    TYPES: [
      {
        key: "essential",
        name: 'Essential',
        cost: 10,
        description: 'All the essentials for advisors',
        features: ['10 Client Accounts', '1 Advisor Account', 'One-Time Invoicing', 'Recurring Auto-Billing', '0 Admin/Analyst Users', 'AdvicePay Logo'],
        selectable: true,
        upgradeMethod: 'user',
        weight: 1,
      },
      {
        key: "professional",
        name: 'Professional',
        cost: 50,
        description: 'For advisors and ensemble firms',
        features: ['All Essential Features', 'UNLIMITED Client Accounts', 'Multiple Advisor Accounts', 'Advanced Payment Settings', 'Customizable invoices, email, and client portal', 'Brand with custom logo', 'eSignature', 'Access to Integrations'],
        selectable: true,
        upgradeMethod: 'user',
        weight: 2,
      },
      {
        key: "enterprise",
        name: 'Enterprise',
        cost: 2500,
        description: 'For large firms needing additional integrations and support.',
        features: ['All Professional Features', 'Enterprise-Friendly Features & Controls', 'Multiple Advisor Management', 'Home Office Portal', 'API access', 'Personalized relationship management'],
        selectable: true,
        upgradeMethod: 'sales',
        weight: 3,
      },
      {
        key: "enterprise_advisor",
        name: 'Enterprise Rep',
        cost: 65,
        description: 'Contact your account owner or support@advicepay.com for more info',
        features: ["Recurring Billing for Various Frequencies", "Compliant Workflows", "eSignature for Client Documents", "Flexible Invoicing Options", "Accept Credit Cards or ACH for Client Payments"],
        upgradeMethod: 'none',
        weight: 4,
      }
    ]
  }
}

export default Plans;